var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { useTheme } from "@mui/material";
import MuiChip from "@mui/material/Chip";
import { baseChipStylesFn, chipTypeStyles } from "./Chip.styles";
export var CHIP_TYPE;
(function (CHIP_TYPE) {
    CHIP_TYPE["INPUT"] = "input";
    CHIP_TYPE["FILTER"] = "filter";
    CHIP_TYPE["CHOICE"] = "choice";
    CHIP_TYPE["ACTION"] = "action";
    CHIP_TYPE["WHITE"] = "white";
})(CHIP_TYPE || (CHIP_TYPE = {}));
var Chip = function (_a, ref) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.chipType, chipType = _c === void 0 ? CHIP_TYPE.FILTER : _c, _d = _a.color, color = _d === void 0 ? "default" : _d, _e = _a.variant, variant = _e === void 0 ? "filled" : _e, disabled = _a.disabled, selected = _a.selected, hideBgMobile = _a.hideBgMobile, dragged = _a.dragged, icon = _a.icon, onClick = _a.onClick, onDelete = _a.onDelete, rest = __rest(_a, ["label", "chipType", "color", "variant", "disabled", "selected", "hideBgMobile", "dragged", "icon", "onClick", "onDelete"]);
    var theme = useTheme();
    var baseStyles = baseChipStylesFn({
        breakpoints: theme.breakpoints,
        hideBgMobile: hideBgMobile,
        chipType: chipType,
    });
    /**
     * Styles the chip's custom Selected state (props.selected === true):
     * Different specs based on Chip variant, Say Chip type, and presence of icon.
     */
    var getSelectedStyles = function () {
        if (variant === "outlined")
            return chipTypeStyles.outlinedSelected;
        else if (chipType === CHIP_TYPE.CHOICE)
            return chipTypeStyles.choiceDefaultSelected;
        else if (chipType === CHIP_TYPE.WHITE) {
            return chipTypeStyles.whiteSelected;
        }
        else if (chipType === CHIP_TYPE.INPUT || onDelete) {
            return icon
                ? chipTypeStyles.inputDefaultSelectedWithIcon
                : chipTypeStyles.inputDefaultSelected;
        }
        else {
            return icon
                ? chipTypeStyles.filterDefaultSelectedWithIcon
                : chipTypeStyles.filterDefaultSelected;
        }
    };
    var consolidatedSelectedStyles = __assign(__assign({}, baseStyles), getSelectedStyles());
    var consolidatedDraggedStyles = __assign(__assign({}, baseStyles), (variant === "outlined"
        ? chipTypeStyles.outlinedDragged
        : chipTypeStyles.defaultDragged));
    var consolidatedStyles = __assign(__assign({}, baseStyles), (chipType === CHIP_TYPE.ACTION ? chipTypeStyles.actionRoot : {}));
    if (selected) {
        return (_jsx(React.Fragment, { children: _jsx(MuiChip, __assign({ sx: consolidatedSelectedStyles, variant: variant, "data-testid": "chip-".concat(label), label: label, ref: ref, color: color, disabled: disabled, onClick: onClick, onDelete: onDelete, icon: icon }, rest)) }));
    }
    // Input and Filter chips have a custom Draggable state (props.selected === true):
    if (dragged) {
        return (_jsx(React.Fragment, { children: _jsx(MuiChip, __assign({ sx: consolidatedDraggedStyles, variant: variant, label: label, color: color, ref: ref, disabled: disabled, "data-testid": "chip-".concat(label), onClick: onClick, onDelete: onDelete, icon: icon }, rest)) }));
    }
    return (_jsx(React.Fragment, { children: _jsx(MuiChip, __assign({ sx: consolidatedStyles, variant: variant, label: label, color: color, ref: ref, disabled: disabled, "data-testid": "chip-".concat(label), onClick: onClick, onDelete: onDelete, icon: icon }, rest)) }));
};
export default forwardRef(Chip);
